const Logout = () => {
    localStorage.removeItem("v");
    localStorage.removeItem("d");
    window.location.href = "/auth/login";
}

export default Logout;